import { TextInput } from "flowbite-react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { FaRegTimesCircle, FaTimes } from "react-icons/fa";
import { HiOutlineSearch } from "react-icons/hi";
import { useDispatch } from 'react-redux';
import { openSnackBar } from '../../../redux/snackBarReducer';
import AddFilter from "../AddFilter";
import NewProduct from "../NewProdjct";

import './producttabletoolbar.scss'

function ProductTableToolbar(props) {
    const { t } = useTranslation();

    const dispatch = useDispatch();

    const [search, setSearch] = useState("");   //search bar text 
    const [filterArray, setFilterArray] = useState([]);

    const changeSearch = (e) => {
        setSearch(e.target.value);
    }

    const keyDownSearch = (e) => {
        var flag = false;
        if (e.keyCode === 13) {
            if (search.trim()) {
                if (filterArray.length > 0) {
                    filterArray.map(data => {
                        if (data.type === "text" && data.value === search.trim()) {
                            flag = true;
                        } else {
                            flag = false;
                        }
                    })
                }
                if (!flag) {
                    setFilterArray([...filterArray, { type: "text", value: search.trim() }]);
                    setSearch("");

                    const { setCondition, getData } = props;
                    setCondition("filterArray", [...filterArray, { type: "text", value: search.trim() }]);
                    setCondition("currentPage", 0);
                    getData();
                } else {
                    dispatch(openSnackBar({ status: "error", message: t("msg_filter_name_exist") }));
                }
            }
        }
    }

    const addFilterArray = (data) => {
        var tmpFilterArray = [];
        for (let filter in data) {
            if (filter === "alc_vol" || filter === "wine_acid" || filter === "residual_sugar") {
                if (data[`${filter}`][0] !== 0 || data[`${filter}`][1] !== 100)
                    tmpFilterArray = [...tmpFilterArray, { type: filter, value: data[`${filter}`][0] + "," + data[`${filter}`][1] }];
            } else if (data[`${filter}`] && data[`${filter}`].length > 0) {
                data[`${filter}`].map((item) => {
                    var flag = false;
                    if (filterArray.length > 0) {
                        for (let i = 0; i < filterArray.length; i++) {
                            if (filterArray[i].type === filter && filterArray[i].value === item.label) {
                                flag = true;
                                break;
                            } else {
                                flag = false;
                                break;
                            }
                        }
                    }
                    if (!flag) {
                        tmpFilterArray = [...tmpFilterArray, { type: filter, value: item.label, id: item.value }];
                    } else {
                        // dispatch(openSnackBar({ status: "error", message: t("msg_filter_name_exist") }));
                    }
                })
            }

        }
        setFilterArray([...filterArray, ...tmpFilterArray]);
        const { setCondition, getData } = props;
        setCondition("filterArray", [...filterArray, ...tmpFilterArray]);
        setCondition("currentPage", 0);
        getData();
    }

    const removeSelectedFilter = (index) => {
        filterArray.splice(index, 1);
        setFilterArray([...filterArray]);

        const { setCondition, getData } = props;
        setCondition("filterArray", [...filterArray]);
        setCondition("currentPage", 0);
        getData();
    }

    const removeAllFilter = () => {
        setFilterArray([]);

        const { setCondition, getData } = props;
        setCondition("filterArray", []);
        setCondition("currentPage", 0);
        getData();
    }

    return (
        <div>
            {/* <div className="flex pb-4 flex-wrap">
                <div>
                    <h2 className="font-bold leading-[40px] text-[30px] tracking-[-0.3px]">Products</h2>
                </div>
                <div className="basis-3/5 px-2 pb-4 md:pb-0 md:flex-1 !w-full md:!w-auto">
                    <TextInput
                        id="searchProduct"
                        type="search"
                        sizing="sm"
                        placeholder={t("what_are_looking")}
                        required={true}
                        icon={HiOutlineSearch}
                        value={search}
                        onChange={(e) => changeSearch(e)}
                        onKeyDown={(e) => keyDownSearch(e)}
                    />
                </div>
                <div className="px-2">
                    <AddFilter addFilterArray={addFilterArray} />
                </div>
                <div className="px-2">
                    <NewProduct condition={props.condition} />
                </div>
            </div> */}
            <div className="producttabletoolbar-layout">
                <div className="header">{t("products")}</div>
                <div className="actions">
                    <TextInput className="item tool-search"
                        id="searchProduct"
                        type="search"
                        sizing="md"
                        placeholder={t("what_are_looking")}
                        required={true}
                        icon={HiOutlineSearch}
                        value={search}
                        onChange={(e) => changeSearch(e)}
                        onKeyDown={(e) => keyDownSearch(e)}
                    />
                    <div className="px-2 item" >
                        <AddFilter addFilterArray={addFilterArray} />
                    </div>
                    <div className="px-2 item">
                        <NewProduct condition={props.condition} />
                    </div>
                </div>
            </div>
            <div className="filter">
                {
                    filterArray?.length > 0 &&
                    <div className="flex pl-4 cursor-pointer" onClick={() => removeAllFilter()}>
                        <div className="inline-flex items-center text-sm font-medium text-slate-100 bg-red-100 rounded-full text-center px-4 py-2">
                            <span className="text-xs text-sitebg-50">{t("remove_all_tag")}</span>
                            <FaRegTimesCircle onClick={() => removeAllFilter()} className="ml-2 h-4 w-4 text-sitebg-50 " />
                        </div>
                    </div>
                }
                {
                    filterArray.map((data, i) =>
                        <div key={i} className="tag item">
                            <p className="tag-text mr-2" >{data.type !== "text" && `${data.type}:`}
                                <b className="text-xs"> "{data.value}"</b>
                            </p>
                            <FaTimes onClick={() => removeSelectedFilter(i)} className="cursor-pointer" />
                        </div>
                    )
                }
            </div>
                        {/* <div key={i} className="cursor-pointer">
                            <div className="inline-flex items-center text-sm font-medium text-slate-100 bg-gray-600 rounded-full text-center px-2 py-1">
                                <FaTimes onClick={() => removeSelectedFilter(i)} className="ml-2 h-4 w-4 mt-1" />
                            </div>
                        </div> */}
            {/* <div className="px-2">
                {
                    filterArray?.length > 0 &&
                    <div className="flex pl-4 pt-2 pb-5" >
                        <div className="inline-flex items-center text-sm font-medium text-slate-100 bg-red-100 rounded-full text-center px-4 py-2">
                            <FaRegTimesCircle onClick={() => removeAllFilter()} className="mr-2 h-4 w-4 text-sitebg-50" />
                            <span className="text-xs text-sitebg-50">{t("remove_all_tag")}</span>
                        </div>
                    </div>
                }
                <div className="flex flex-wrap gap-4 px-4">
                    {
                        filterArray.map((data, i) =>
                            <div key={i} className="bg-gray-200 text-gray-700 font-medium leading-tight rounded-xl shadow-md cursor-pointer">
                                <div className="inline-flex p-2 text-sm font-medium bg-indigo-100 text-indigo-600 rounded-full text-center px-2.5 py-1">
                                    <p>{data.type !== "text" && `${data.type}:`}
                                        <b className="text-sm"> "{data.value}"</b>
                                    </p>
                                    <FaTimes onClick={() => removeSelectedFilter(i)} className="ml-2 h-4 w-4 mt-1" />
                                </div>
                            </div>
                        )
                    }
                </div>
            </div> */}
        </div>
    );
}

export default ProductTableToolbar;
